import { GoogleMap } from '@belong/ui';
import GoogleMapReact from 'google-map-react';
import { Coordinates } from 'src/api/models';

type StreetViewProps = {
  coordinates: Coordinates;
  options?: GoogleMapReact.MapOptions;
};

const googleMapsApiKey = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY as string;

export function StreetView({ coordinates, options = {} }: StreetViewProps) {
  const { latitude, longitude } = coordinates;

  const handleApiLoaded = (map: google.maps.Map): void => {
    const panorama = map.getStreetView()!;
    panorama.setPosition({
      lat: Number(latitude),
      lng: Number(longitude),
    });
    panorama.setPov({
      heading: 34,
      pitch: 10,
    });
    panorama.setVisible(true);
    panorama.setOptions({ enableCloseButton: false, ...options });
    panorama.setMotionTracking(false);
  };

  return (
    <div className="size-full">
      <GoogleMap
        yesIWantToUseGoogleMapApiInternals
        bootstrapURLKeys={{ key: googleMapsApiKey }}
        defaultZoom={8}
        center={{
          lat: Number(latitude),
          lng: Number(longitude),
        }}
        onGoogleApiLoaded={({ map }) => handleApiLoaded(map)}
      />
    </div>
  );
}
